import { EStoreSearchRequest } from '@gelato-api-ui/core/e-commerce/e-store-search-request';

export const getDefaultStoresListRequest = (clientId?: string): EStoreSearchRequest => ({
  clientId,
  limit: 100,
  offset: 0,
});
